<template>
  <span class="text-left">
    <ed-button :button-class="buttonClass"
               style="margin-bottom: 10px;"
               @click="showReject = true"
               :ids="ids"
               :disabled="disabled"
               v-tooltip="tooltip">
      Decline
    </ed-button>
    <ed-modal title="Decline Card" :show="showReject" @close="showReject = false, rejectReason = ''" @confirm='approveOrReject()' validation @validate='approveOrReject' primary-button="Decline" primaryButtonClass="btn btn-danger" :modalEndpoint="api.$.evedpaycard.approveOrReject">
      <div slot="body" class='reject-card-overlay'>
        <p class="small">Provide a reason for declining the card.</p>
        <label>Reason</label>
        <ed-input type='text' v-model='rejectReason' @input="(value) => rejectReason = value" />
      </div>
    </ed-modal>
  </span>
</template>

<script>
export default {
  data() {
    return {
      rejectReason: '',
      showReject: false
    }
  },
  created() {
  },
  props: {
    ids: null,
    disabled: false,
    tooltip: '',
    selectedRows: [],
    card: [],
    buttonClass: {
      type: String,
      default: 'btn btn-actionbar col-md-12'
    }
  },
  methods: {
    async approveOrReject() {
      try {
        let cardId

        if (this.selectedRows && this.selectedRows.length > 0) {
          cardId = this.selectedRows[0].data.Id
        } else {
          cardId = this.card.Id
        }

        let payload = {
          cardsData: JSON.stringify([{ Id: cardId, RejectReason: this.rejectReason }])
        }
        const response = await this.api.post(this.api.$.evedpaycard.approveOrReject, payload)

        if (!response.data) {
          throw new Error('Error during the request')
        } else {
          this.$emit('success', cardId)
        }
        if (response.status === 200) {
          this.showReject = false
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .reject-card-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/RejectCard.vue